import React, { memo, useCallback, useEffect, useState } from "react";
import { Form, ListGroup } from "react-bootstrap";
import Input from "../../../components/Common/Input";
import FaArrowRightLong from "../../../constants/icons/Fa6/FaArrowRightLong";
import RenderLatexContent from "../../../components/RenderLatexContent";

function DisplayOptions({
  data,
  userAnswer = [],
  updateUserAnswer,
  isAttempted = false,
  isTestAttempt = false,
  isCorrectAnswert = () => {},
  isMobileView = false,
  eliminatedOptions = [],
  handleEliminationOption = () => {},
  isEliminationEnable = false,
  handleToggleEliminateButtons = () => {},
  isSatExam = false,
}) {
  const [matchingOptions, setMatchingOptions] = useState([]);

  const handleInputChange = (e) => {
    // data?.type === "numerical"
    if (
      (data?.type === "blank" || data?.type === "multiple_blanks") &&
      data?.wordsCount &&
      data?.wordsCount > 0
    ) {
      const val = e.target.value.split(" ");
      if (val?.length > data?.wordsCount) {
        return;
      }
    }
    if (data?.type === "numerical") {
      let input = e.target.value.trim(); // Trim leading and trailing spaces
      if (input?.includes("\n")) {
        input.replace("\n", "");
      }
      input = input.replace(/[^0-9./-]/g, ""); // Allow only digits, '/', '.', and '-' characters

      if (input[0] === "-" && input.length > 6) {
        updateUserAnswer(userAnswer);
        return;
      } else if (input[0] !== "-" && input.length > 5) {
        updateUserAnswer(userAnswer);
        return;
      }
    }
    updateUserAnswer(e.target.value);
  };

  const handleCheckboxChange = (option) => {
    let updatedAnswer = [...userAnswer];
    if (!userAnswer.includes(option)) {
      updatedAnswer.push(option);
    } else {
      updatedAnswer = updatedAnswer.filter((ans) => ans !== option);
    }
    updateUserAnswer(updatedAnswer);
  };

  // For matching questions, combine correct answers and distractors then shuffle.
  useEffect(() => {
    if (data?.type === "matching") {
      const correctValues =
        data?.options?.map((option) => option?.rightSide) || [];
      const distractorValues = data?.distractors || [];
      const combined = [...correctValues, ...distractorValues];
      const shuffled = combined.slice();
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      setMatchingOptions(shuffled);
    }
  }, [data?.options, data?.type, data?.distractors]);

  const onMatchingChange = (index, value) => {
    const updatedAnswer = [...userAnswer];
    updatedAnswer[index] = value;
    updateUserAnswer(updatedAnswer);
  };

  const optionText = 65; // ASCII value for 'A'

  const getBorderColor = useCallback(
    (optionIndex) => {
      if (isAttempted && !isTestAttempt) {
        if (optionIndex === userAnswer && isCorrectAnswert(optionIndex)) {
          return "1px solid #23BD33";
        }
        if (optionIndex !== userAnswer && isCorrectAnswert(optionIndex)) {
          return "1px solid #23BD33";
        }
        if (optionIndex === userAnswer && !isCorrectAnswert(optionIndex)) {
          return "1px solid red";
        }
      } else if (optionIndex === userAnswer) {
        return "1px solid #ff6636";
      }
      return "";
    },
    [isAttempted, isCorrectAnswert, isTestAttempt, userAnswer]
  );

  const getMultipleAnswerBorderColor = useCallback(
    (optionIndex) => {
      if (isAttempted && !isTestAttempt) {
        if (userAnswer.includes(optionIndex) && isCorrectAnswert(userAnswer)) {
          return "1px solid #23BD33";
        }
        if (
          userAnswer.includes(optionIndex) &&
          !isCorrectAnswert(optionIndex)
        ) {
          return "1px solid red";
        }
      } else if (userAnswer.includes(optionIndex)) {
        return "1px solid #ff6636";
      }
      return "";
    },
    [isAttempted, isCorrectAnswert, isTestAttempt, userAnswer]
  );

  const getMatchingBorderColor = useCallback(
    (index) => {
      if (isAttempted && !isTestAttempt) {
        if (userAnswer[index] && isCorrectAnswert(userAnswer)) {
          return "1px solid #23BD33";
        }
        if (userAnswer[index] && !isCorrectAnswert(userAnswer)) {
          return "1px solid red";
        }
      }
    },
    [isAttempted, isCorrectAnswert, isTestAttempt, userAnswer]
  );

  return (
    <div>
      {(data?.type === "mcq" || data?.type === "true_false") && isSatExam && (
        <div style={{display: 'flex', justifyContent: 'end', alignItems: 'center'}}>
          <button
          className="eliminate-button"
          aria-label="Eliminate option"
          onClick={handleToggleEliminateButtons}
          style={{ marginLeft: "5px", marginBottom: '10px' }}
        >
          <span
            style={{
              backgroundColor: isEliminationEnable ? "blue" : "",
              color: isEliminationEnable ? "white" : "",
              textDecoration: "line-through",
            }}
            className="option-index"
          >
            S
          </span>
        </button>
        </div>
      )}
      {(data?.type === "mcq" || data?.type === "true_false") &&
        data?.options?.map((option, optionIndex) => {
          const isEliminated = eliminatedOptions?.includes(optionIndex);
          return (
        <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>         
          <div
            key={optionIndex}
            className={`card ${!isAttempted ? "option-hover" : ""} ${isEliminated && isSatExam ? 'eliminated-option' : ''}`}
            style={{
              display: "flex",
              width: '100%',
              alignItems: "center",
              gap: isMobileView ? "6px" : "10px",
              marginBottom: isMobileView ? "6px" : "10px",
              flexDirection: "row",
              padding: isMobileView ? "6px" : "8px",
              cursor: "pointer",
              border: getBorderColor(optionIndex),
            }}
            onClick={() => {
              if (!isAttempted) {
                updateUserAnswer(optionIndex);
              }
            }}
          >
            <div
              style={{
                fontSize: isMobileView ? "9px" : "16px",
                fontWeight: 500,
                lineHeight: "22px",
                color: "white",
                backgroundColor: "#363B47",
                borderRadius: "50px",
                height: isMobileView ? "18px" : "30px",
                width: isMobileView ? "18px" : "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {String.fromCharCode(optionText + optionIndex)}
            </div>
            <div className="mx-2">
              <RenderLatexContent content={option} />
            </div>
          </div>
          {isEliminationEnable && isSatExam && (
            <>{ isEliminated ? <button
                    onClick={() => handleEliminationOption(optionIndex)}
                    className="undo-button"
                    aria-label="Undo eliminate"
                    style={{
                      marginBottom: '10px'
                    }}
                  >
                    Undo
                  </button> : 
                  <div
                    style={{
                      fontSize: isMobileView ? "9px" : "16px",
                      fontWeight: 500,
                      lineHeight: "22px",
                      color: "black",
                      border: '1px solid black',
                      borderRadius: "50px",
                      height: isMobileView ? "18px" : "30px",
                      width: isMobileView ? "18px" : "30px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: 'pointer',
                      marginBottom: '10px'
                    }}
                    onClick={()=>{
                      handleEliminationOption(optionIndex)
                    }}
                  >
                    {String.fromCharCode(optionText + optionIndex)}
                  </div> 
            }
            </> 
          )}
        </div>
        )}
      )}

      {data?.type === "multiple_answers" &&
        data?.options?.map((option, optionIndex) => (
          <div
            key={optionIndex}
            className={`card ${!isAttempted ? "option-hover" : ""}`}
            style={{
              display: "flex",
              gap: isMobileView ? "6px" : "10px",
              marginBottom: isMobileView ? "6px" : "10px",
              flexDirection: "row",
              padding: isMobileView ? "6px" : "8px",
              cursor: "pointer",
              alignItems: "center",
              border: getMultipleAnswerBorderColor(optionIndex),
            }}
          >
            <Input
              className="mbl-card-checkbox"
              type="checkbox"
              disabled={isAttempted}
              checked={userAnswer.includes(optionIndex)}
              onChange={() => handleCheckboxChange(optionIndex)}
            />
            <span className="mx-2">
              <RenderLatexContent content={option} />
            </span>
          </div>
        ))}

      {data?.type === "matching" &&
        data?.options?.map((option, optionIndex) => (
          <div
            key={optionIndex}
            className="card"
            style={{
              display: "flex",
              gap: isMobileView ? "6px" : "10px",
              marginBottom: isMobileView ? "6px" : "10px",
              flexDirection: "row",
              padding: isMobileView ? "6px" : "8px",
              alignItems: "center",
              justifyContent: "space-between",
              border: getMatchingBorderColor(optionIndex),
            }}
          >
            <div
              className="mx-2 d-flex align-items-center"
              style={{ gap: "8px" }}
            >
              <RenderLatexContent content={option?.leftSide} />
            </div>
            <FaArrowRightLong
              size={24}
              color={
                isAttempted && !isTestAttempt
                  ? ""
                  : userAnswer[optionIndex] && "#ff6636"
              }
            />
            <Form.Select
              aria-label="select-matching-option"
              style={{ width: "40%" }}
              value={userAnswer[optionIndex] || ""}
              disabled={isAttempted}
              onChange={(e) => onMatchingChange(optionIndex, e.target.value)}
            >
              <option value={""}>Select Option...</option>
              {matchingOptions?.map((matchOption, idx) => (
                <option key={idx} value={matchOption}>
                  {matchOption}
                </option>
              ))}
            </Form.Select>
          </div>
        ))}

      {(data?.type === "blank" || data?.type === "numerical") && (
        <ListGroup.Item>
          <div className="d-flex align-items-center p-0 display-options">
            <Form.Control
              value={userAnswer}
              onChange={handleInputChange}
              as="textarea"
              placeholder={"Add your answer..."}
              rows={5}
              disabled={isAttempted}
              className={`${
                isAttempted && !isTestAttempt
                  ? isCorrectAnswert(userAnswer)
                    ? "success-border"
                    : "error-border"
                  : ""
              }`}
            />
          </div>
        </ListGroup.Item>
      )}
    </div>
  );
}

export default memo(DisplayOptions);
